import Modal from "../shared/Modal";
import "./ModalDeleteResourceConfirm.css";

type ModalDeleteResourceConfirmProps = {
  isOpen: boolean;
  onClose: () => void;
  onContinue: () => void;
};

const ModalDeleteResourceConfirm = ({
  isOpen,
  onClose,
  onContinue,
}: ModalDeleteResourceConfirmProps) => {
  if (!isOpen) {
    return null;
  }

  return (
    <>
      <Modal
        isOpen={isOpen}
        style={null}
        onClose={onClose}
        canClose={false}
        allowClickout={true}>
        <div id="modal-collection-delete-resource-confirm">
          <div className="modal-collection-delete-resource-confirm-title">
            Delete this Resource
          </div>

          <div className="modal-collection-delete-resource-confirm-content">
            Do you wish to delete this resource from Winslow? This will remove
            it from your knowledge base and its contents won't be included in
            any future answers to questions. You can add it again at any time
            from the configure menu.
          </div>

          <div className="modal-collection-delete-resource-confirm-footer">
            <div className="modal-collection-delete-resource-confirm-buttons">
              <button onClick={onClose} className="collections-button-negative">
                Cancel
              </button>
              <button
                onClick={() => onContinue()}
                className="collections-button">
                Continue with Delete
              </button>
            </div>
          </div>
        </div>
      </Modal>
    </>
  );
};

export default ModalDeleteResourceConfirm;
